import script from "./IndexJabatan.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexJabatan.vue?vue&type=script&setup=true&lang=js"

import "./IndexJabatan.vue?vue&type=style&index=0&id=1455e932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1455e932"]])

export default __exports__